import ActionRow from '../ActionRow/ActionRow';
import type { Report } from '../../types';
import styles from './styles/styles.module.scss';

type ReportIssueProps = {
  reports: Report[];
  onReportSelect: (report: Report) => void;
};

export default function ReportIssue({ reports, onReportSelect }: ReportIssueProps) {
  return (
    <div className={styles.container}>
      {reports.map(report => (
        <ActionRow key={report.id} label={report.label} onClick={() => onReportSelect(report)} />
      ))}
    </div>
  );
}
